/* RESPONSIBLE TEAM: team-ml */
import StepSerializer from '../step';

export default StepSerializer;
